import { classNames } from "primereact/utils";


const iconfield = {
    root: {
        className: classNames('relative')
    }
};

const inputicon = {
    root: ({ context }) => ({
        className: classNames('absolute top-1/2 -mt-2 z-10 text-allstate-blue', {
            'left-4': context.iconPosition === 'left',
            'right-4': context.iconPosition === 'right'
        })
    })
};


//     // For each input wrapped with IconField you will need to add styling.
//     //  The following is an example for InputText
//     inputtext: {
//         root: ({ props, context }) => ({
//             className: classNames(
//                 // Extend the root stylings with the following:
//                 {
//                     'pl-8': context.iconPosition === 'left',
//                     'pr-8': props.iconPosition === 'right'
//                 }
//             )
//         })
//     },
// }
        

export {
  inputicon,
  iconfield,
}